import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnInit } from '@angular/core';
import { TransactionsService } from '@services/entity/transactions.service';
import { CustomersService } from '@services/entity/customers.service';
import { TransactionDto } from '@dto/transactionDto';

@Component({
  selector: 'app-account-dashboard',
  templateUrl: './account-dashboard.component.html',
  styleUrls: ['./account-dashboard.component.scss']
})
export class AccountDashboardComponent extends ComponentBase implements OnInit {

  public className = 'AccountDashboardComponent';
  dashboardTitle = '';
  readonly defaultTitle = $localize`:@@AccountDashboardTitle:Konto-Dashboard`;
  showRunningTransactions = false;
  runningTransactions: TransactionDto[] = [];
  componentReady = false;

  constructor(
    private transactionsService: TransactionsService,
    private customersService: CustomersService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.customersService.getSelectedCustomer().subscribe({
      next: (customer) => {
        this.dashboardTitle = (customer?.internalDescription?.trim()) || '';
      },
      error: () => {}
    });
    this.checkRunningTransactions();
    this.componentReady = true;
  }

  checkRunningTransactions(): void {
    this.transactionsService.getRunningTransactions().subscribe({
      next: (result) => {
        if (result?.length >= 1) {
          this.runningTransactions = result;
          this.showRunningTransactions = true;
        }
      },
      error: () => {}
    });
  }
}
